export default "__VITE_ASSET__DkDhaEer__"